import { CASES, type CaseStudy } from "@/content/cases";

type BnCaseCopy = Pick<CaseStudy, "slug" | "client" | "industry" | "region" | "headline" | "summary" | "problem" | "strategy" | "result" | "duration">;

const BN_COPY: BnCaseCopy[] = [
  {
    "slug": "danceamor-adelaide-seo-shopify",
    "client": "DanceAmor (অস্কার কাস্তেয়ানোস)",
    "industry": "ড্যান্স স্টুডিও / Shopify ই-কমার্স",
    "region": "অ্যাডিলেড, অস্ট্রেলিয়া",
    "headline": "DanceAmor: ওয়েবসাইট ও Shopify কাজের উদাহরণ",
    "summary": "ওয়েবসাইট, ক্যাম্পেইন বা কীওয়ার্ড গবেষণার কাজের উদাহরণ। যাচাইকৃত আগে-পরে ফলাফলের তথ্য প্রকাশিত নেই।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "সাইটের ক্রলযোগ্যতা, টাইটেল ও নেভিগেশন পরীক্ষা করুন।",
      "প্রোডাক্ট ও কালেকশন পেজের তথ্য এবং কেনাকাটার বিবরণ যাচাই করুন।",
      "প্রকৃত লোকাল প্রোফাইলে ব্যবসার তথ্যের সামঞ্জস্য দেখুন।",
      "তারিখসহ সঠিক সাইটের ডেটা দিয়ে সার্চ পারফরম্যান্স মাপুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের সংখ্যাভিত্তিক ফলাফল ও সময়সীমার সমর্থনে রেকর্ড নেই, তাই সেগুলো প্রত্যাহার করা হয়েছে। ছবিগুলো কাজের উদাহরণ, ব্যবসায়িক ফলাফলের প্রমাণ নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "schildermij-swiss-painting-seo",
    "client": "schildermij.nl (সিসকা ফান সেলম)",
    "industry": "চারুকলা / পোর্ট্রেট পেইন্টিং",
    "region": "সুইজারল্যান্ড",
    "headline": "schildermij.nl: এসইও পর্যালোচনার ব্যবহারিক পদ্ধতি",
    "summary": "উদাহরণভিত্তিক ব্যবহারিক নির্দেশনা; যাচাইকৃত ক্লায়েন্ট প্রজেক্ট বা ফলাফল নয়।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "সাইটের প্রকৃত সেবার এলাকা ও দর্শক যাচাই করে কীওয়ার্ড বাছুন।",
      "ইনডেক্সেশন, পোর্টফোলিওর ব্যাখ্যা ও ইন্টারনাল লিংক পরীক্ষা করুন।",
      "সত্য তথ্য অনুযায়ী লেখক বা Artwork স্কিমা বাছুন।",
      "যাচাইকৃত ডেটা পেলে সমান সময়ের Search Console রিপোর্ট তুলনা করুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের ক্লায়েন্টের গল্প ও সংখ্যাভিত্তিক ফলাফলের সমর্থনে রেকর্ড নেই। এটি এখন উদাহরণভিত্তিক নির্দেশনা, সম্পন্ন প্রজেক্ট বা যাচাইকৃত ফলাফল নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "danse-evasion-social-media",
    "client": "Danse Évasion",
    "industry": "ড্যান্স স্কুল / পারফর্মিং আর্টস",
    "region": "সুইজারল্যান্ড",
    "headline": "Danse Évasion: সোশ্যাল ক্যাম্পেইনের উদাহরণ",
    "summary": "ওয়েবসাইট, ক্যাম্পেইন বা কীওয়ার্ড গবেষণার কাজের উদাহরণ। যাচাইকৃত আগে-পরে ফলাফলের তথ্য প্রকাশিত নেই।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "প্রকৃত ট্রায়াল-ক্লাস অফার অনুযায়ী ক্যাম্পেইন ক্যালেন্ডার তৈরি করুন।",
      "ক্রিয়েটিভ ও ইভেন্টের তথ্য সামঞ্জস্যপূর্ণ রাখুন।",
      "সঠিক রেজিস্ট্রেশন লিংক ও অফারের তারিখ দিন।",
      "প্ল্যাটফর্মের রিপোর্ট ও রেজিস্ট্রেশন রেকর্ড দিয়ে রিচ ও সাইনআপ মাপুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের সংখ্যাভিত্তিক ফলাফল ও সময়সীমার সমর্থনে রেকর্ড নেই, তাই সেগুলো প্রত্যাহার করা হয়েছে। ছবিগুলো কাজের উদাহরণ, ব্যবসায়িক ফলাফলের প্রমাণ নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "cbd-keyword-research",
    "client": "Rena's Organic",
    "industry": "স্বাস্থ্য ও ওয়েলনেস (CBD)",
    "region": "যুক্তরাষ্ট্র",
    "headline": "Rena’s Organic: কীওয়ার্ড গবেষণার উদাহরণ",
    "summary": "ওয়েবসাইট, ক্যাম্পেইন বা কীওয়ার্ড গবেষণার কাজের উদাহরণ। যাচাইকৃত আগে-পরে ফলাফলের তথ্য প্রকাশিত নেই।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "দর্শকের উদ্দেশ্য ও পণ্যের ধরন অনুযায়ী কীওয়ার্ড সাজান।",
      "সার্চ ভলিউমের উৎস ও তারিখ লিখে রাখুন।",
      "সঠিক পেজে কীওয়ার্ড ম্যাপ করুন; অপ্রমাণিত স্বাস্থ্য দাবি এড়ান।",
      "স্প্রেডশিট থেকে ব্যবসায়িক ফল আলাদাভাবে মাপুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের সংখ্যাভিত্তিক ফলাফল ও সময়সীমার সমর্থনে রেকর্ড নেই, তাই সেগুলো প্রত্যাহার করা হয়েছে। ছবিগুলো কাজের উদাহরণ, ব্যবসায়িক ফলাফলের প্রমাণ নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "germany-agency-seo",
    "client": "B2B এজেন্সির উদাহরণ",
    "industry": "B2B সেবা",
    "region": "জার্মানি",
    "headline": "B2B এজেন্সির এসইও: উদাহরণভিত্তিক পদ্ধতি",
    "summary": "উদাহরণভিত্তিক ব্যবহারিক নির্দেশনা; যাচাইকৃত ক্লায়েন্ট প্রজেক্ট বা ফলাফল নয়।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "সার্ভিস পেজ, ক্রলযোগ্যতা ও ভাষার সমতুল্য পেজ পরীক্ষা করুন।",
      "প্রমাণসহ টেকনিক্যাল সমস্যার অগ্রাধিকার নির্ধারণ করুন।",
      "উপকারী ব্যাখ্যা ও প্রাসঙ্গিক ইন্টারনাল লিংক দিন।",
      "স্পষ্ট পদ্ধতিতে প্রকৃত অর্গানিক ইনকোয়ারি মাপুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের ক্লায়েন্টের গল্প ও সংখ্যাভিত্তিক ফলাফলের সমর্থনে রেকর্ড নেই। এটি এখন উদাহরণভিত্তিক নির্দেশনা, সম্পন্ন প্রজেক্ট বা যাচাইকৃত ফলাফল নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "elementor-seo-build",
    "client": "লোকাল সেবা ব্যবসার উদাহরণ",
    "industry": "হোম সার্ভিস",
    "region": "বাংলাদেশ",
    "headline": "লোকাল সেবার ওয়েবসাইট: এসইওসহ নির্মাণের উদাহরণ",
    "summary": "উদাহরণভিত্তিক ব্যবহারিক নির্দেশনা; যাচাইকৃত ক্লায়েন্ট প্রজেক্ট বা ফলাফল নয়।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "মোবাইলে ব্যবহারযোগ্য সার্ভিস ও যোগাযোগ পেজ তৈরি করুন।",
      "প্রকাশিত পেজের পারফরম্যান্স পরীক্ষা করুন।",
      "যোগ্য Google Business Profile-এ সত্য তথ্য রাখুন।",
      "নথিভুক্ত বেসলাইনের সঙ্গে প্রকৃত ইনকোয়ারি তুলনা করুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের ক্লায়েন্টের গল্প ও সংখ্যাভিত্তিক ফলাফলের সমর্থনে রেকর্ড নেই। এটি এখন উদাহরণভিত্তিক নির্দেশনা, সম্পন্ন প্রজেক্ট বা যাচাইকৃত ফলাফল নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "saas-technical-audit",
    "client": "SaaS মাইগ্রেশনের উদাহরণ",
    "industry": "SaaS",
    "region": "সিঙ্গাপুর",
    "headline": "SaaS মাইগ্রেশনের এসইও: সমস্যা নির্ণয়ের ধাপ",
    "summary": "উদাহরণভিত্তিক ব্যবহারিক নির্দেশনা; যাচাইকৃত ক্লায়েন্ট প্রজেক্ট বা ফলাফল নয়।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "মাইগ্রেশনের আগে-পরে প্রভাবিত URL তুলনা করুন।",
      "URL Inspection দিয়ে রেসপন্স ও রেন্ডার হওয়া কনটেন্ট পরীক্ষা করুন।",
      "রিডাইরেক্ট, ক্যানোনিক্যাল, ভাষার নির্দেশনা ও ইন্টারনাল লিংক যাচাই করুন।",
      "নির্দিষ্ট রিকভারি সময়ের প্রতিশ্রুতি ছাড়া ইনডেক্সেশন ও ট্রাফিক পর্যবেক্ষণ করুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের ক্লায়েন্টের গল্প ও সংখ্যাভিত্তিক ফলাফলের সমর্থনে রেকর্ড নেই। এটি এখন উদাহরণভিত্তিক নির্দেশনা, সম্পন্ন প্রজেক্ট বা যাচাইকৃত ফলাফল নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  },
  {
    "slug": "ecommerce-local-bd",
    "client": "ই-কমার্সের উদাহরণ",
    "industry": "ই-কমার্স",
    "region": "বাংলাদেশ",
    "headline": "দ্বিভাষিক ই-কমার্স এসইও: উদাহরণভিত্তিক পদ্ধতি",
    "summary": "উদাহরণভিত্তিক ব্যবহারিক নির্দেশনা; যাচাইকৃত ক্লায়েন্ট প্রজেক্ট বা ফলাফল নয়।",
    "problem": "কোন উন্নতি প্রয়োজন তা নির্ধারণের আগে সংশ্লিষ্ট পেজ ও তথ্য পরীক্ষা করা দরকার। শুরুর ট্রাফিক, র‍্যাঙ্কিং বা লিডের যাচাইকৃত বেসলাইন প্রকাশিত নেই।",
    "strategy": [
      "প্রকৃত দর্শকের বাংলা ও ইংরেজি প্রশ্ন খুঁজুন।",
      "সঠিক তথ্য দিয়ে উপকারী ক্যাটাগরি ও প্রোডাক্ট পেজ তৈরি করুন।",
      "উপযুক্ত প্রোডাক্ট ডেটা ও আসল রিভিউ ব্যবহার করুন।",
      "যাচাইকৃত ট্র্যাকিংয়ে সার্চ ট্রাফিক ও বিক্রি আলাদাভাবে মাপুন।"
    ],
    "result": "সংশোধন — ৩১ অক্টোবর ২০২৬: আগের ক্লায়েন্টের গল্প ও সংখ্যাভিত্তিক ফলাফলের সমর্থনে রেকর্ড নেই। এটি এখন উদাহরণভিত্তিক নির্দেশনা, সম্পন্ন প্রজেক্ট বা যাচাইকৃত ফলাফল নয়।",
    "duration": "যাচাইকৃত ক্যাম্পেইনের সময়কাল প্রকাশিত নেই"
  }
];

export type BnCaseStudy = CaseStudy & { enPath: string };
export const BN_CASES: BnCaseStudy[] = BN_COPY.flatMap((bn) => {
  const en = CASES.find((c) => c.slug === bn.slug);
  if (!en) return [];
  return [{ ...en, ...bn, enPath: `/case-studies/${bn.slug}` }];
});

